import request from '@/common/api'
import { HOSTS } from '../utils/env'

/** 活动企业验证方式 1-邮箱验证，2-核销码验证 */
export enum VerificationTypeEnum {
  EMAIL = 1,
  CODE = 2
}
export interface ILoginAdminInfo {
  entId: number;
  entAdminId: string;
  entAdminName: string;
  email: string | null;
  staffId: string | null;
  adminType: number;
  entName: string;
  /** 是否活动创建企业(绑定) */
  activityCreation: boolean;
  verificationTypes: VerificationTypeEnum[];
}

export const getLoginInfo = () => request.get<ILoginAdminInfo>(`${HOSTS.BASE}/api/entweb/entAdmin/detail`)
export const logout = () => request.get<{entName:string, entAdminName:string }>(`${HOSTS.BASE}/api/entweb/entAdmin/logout`)


